export default __webpack_public_path__ + "static/media/m.4fb4613f.png";